import { USER_IN_ADMIN_FIELDS } from 'Users';
import { type DocumentCollection } from './AdminStudentRecordsTab.types';

// USER_IN_ADMIN_FIELDS already covers everything the BaseUser AOI helpers read, including
// prefUserProgramFieldStateId, userProgramFieldStates, userProgramStates and the three AOI record
// collections. The rest are the document fields this tab reads and writes.
//
// Every field this tab sends in a save must also be listed here. A field that is fetched but not
// listed reads as undefined and the save writes a null over real data.
export const USER_STUDENT_RECORDS_FIELDS = [
    ...USER_IN_ADMIN_FIELDS,
    // Required by users_controller#raise_if_old_version, which 406s without it.
    'updatedAt',
    'careerProfile',
    'transcriptsVerified',
    'englishLanguageProficiencyDocumentsApproved',
    'englishLanguageProficiencyDocumentsType',
    'englishLanguageProficiencyComments',
    'englishLanguageProficiencyInternalNotes',
    's3EnglishLanguageProficiencyDocuments',
    'supplementalEnrollmentNotes',
    's3SupplementalEnrollmentDocuments',
    's3TranscriptAssets',
];

// downloadUrl and the upload URLs are not serialised. They were Iguana getters and statics on
// S3TranscriptAsset, S3EnglishLanguageProficiencyDocument and S3SupplementalEnrollmentDocument.
export const uploadUrl = (collection: DocumentCollection) => `${window.ENDPOINT_ROOT}/api/${collection}.json`;
export const downloadUrl = (collection: DocumentCollection, id: string) =>
    `${window.ENDPOINT_ROOT}/api/${collection}/${id}/file`;

// The value of the "🤖 Automatically choose" option in the official-transcript-required select.
// The old code used the number -1; a MUI Select value has to be a string here because every other
// option is an education experience UUID.
export const AUTOMATIC_OVERRIDE_VALUE = 'automatic';

// The empty option is how an admin clears a type back to nil, and it is what a freshly uploaded
// transcript shows before anyone classifies it. The old template offered it as a blank `<option>`,
// which a native select sizes like any other; a MUI MenuItem with no children collapses to a sliver,
// so it needs a label.
export const TRANSCRIPT_TYPE_OPTIONS = [
    { value: '', label: 'None' },
    { value: 'official', label: 'Official' },
    { value: 'unofficial', label: 'Unofficial' },
    { value: 'internal', label: 'Internal' },
];

// The width the tab's form fields share, so the status, waiver, reason and documentation-type
// controls line up down the page.
export const FIELD_WIDTH = { maxWidth: 420 };
